<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lSeJCA/tc-custom/9781504015622.jpg?1699984631657" alt="This image is the cover for the book Woman in Black"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Woman in Black
      </h1>
      <p class="bookDescription body article font2">
        <b>A housekeeper’s daughter and a daughter of privilege find their fortunes reversed in this novel by the <i>New York Times</i>–bestselling author of <i>The Diary</i>.</b><br/><br/> The caretaker’s cottage is the only home fifteen-year-old Abigail Armstrong has ever known. She and her mother, Rosalie, work for the well-to-do Meriwhethers. Lila Meriwhether is Abigail’s best friend, and Abigail has fallen in love with Lila’s twin brother, Vaughn. But one day the unthinkable happens: The employers who’d always treated them like family accuse Rosalie of stealing a diamond necklace and banish her and Abigail. A quarter of a century will pass before Abigail sees Lila or Vaughn again.<br/>  <br/> Twenty-five years later, Lila is leading a charmed life as the Park Avenue wife of a powerful businessman. But a scandal leaves her and her son nearly bankrupt. Abigail, the owner of a celebrated homemaking empire, is meanwhile coping with the fallout from a fire in her Mexico factory. In a capricious twist of fate, Lila is forced to take a job as Abigail’s housekeeper. But it is Vaughn, now a documentary filmmaker, who will shake up Abigail’s world and force her to confront the girl she used to be.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eileen Goudge
      </h2>
      
      <p class="authorDescription body article">Eileen Goudge (b. 1950) is one of the nation&rsquo;s most successful authors of women&rsquo;s fiction. She began as a young adult writer, helping to launch the phenomenally successful <i>Sweet Valley High</i> series, and in 1986 she published her first adult novel, the <i>New York Times </i>bestseller <i>Garden of Lies</i>.&#160;She has since published twelve more novels, including the three-book saga of Carson Springs, and <i>Thorns of Truth</i>, a sequel to <i>Gardens of Lies</i>. She lives and works in New York City. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0119b39c